import { jsx as _jsx } from "react/jsx-runtime";
import { InfoOutlinedIcon } from "@ting/ting-ui-components/dist/icons";
import { Tag, Text } from "@ting/ting-ui-components";
import { classNameFactory } from "@src/utils/dom";
import "./emptyState.scss";
const cn = classNameFactory("empty-state");
export const EmptyState = ({ title }) => {
    return (_jsx(Tag, { fill: true, className: cn(""), type: "corepass", size: "large", rounded: "small", startIcon: _jsx(InfoOutlinedIcon, { width: 24, height: 24 }), children: _jsx(Text, { size: "body-medium", children: title }) }));
};
